import { createFileRoute, redirect } from '@tanstack/react-router';

import { getPreferredLocale } from '@shared/config/i18n';

export const Route = createFileRoute('/dashboard')({
  beforeLoad: () => {
    const locale = getPreferredLocale();

    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/$locale/team-dashboard', params: { locale } });
  },
});
